<template>
  <div id="manage">
    <div class="content">
        <div class="title">学生考级管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input
                        id="demo"
                        v-model="searchModel.keyword"
                        icon="ios-search"
                        placeholder="输入关键字搜索"
                        style="width: 200px;height:34px;border:1px solid #e7e7eb;margin:20px 0;"
                        class="bradius"
                        @on-click="getGradingTestList(1)"
                        @keyup.enter.native="getGradingTestList(1)"
                        autocomplete="off"></Input>
                    </div>
                    <div class="fl_right addClass" @click="addExam">新增学生考级</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="examColumns" :data="examList" :loading="loading"></Table>
                    <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
                </div>
            </div>
            <!-- 添加 -->
            <div class="alertBox" v-if="alertShow" style="padding-top:3%;">
                <div class="tanchuan" style="width:780px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">学生考级</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div style="height:80vh;">
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">考级名称<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addModel.name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入考级名称" />
                                    <input type="text"  autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">考级级别<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addModel.level_id" multiple class="bordiv" placeholder="请选择级别" filterable style="width:440px;height:66px;margin-bottom:20px;">
                                        <Option v-for="item in levelList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">承办单位<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addModel.company_id" class="bordiv" placeholder="请选择承办单位" filterable style="width:440px;">
                                        <Option v-for="item in companyList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">所在城市<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addModel.province_id" class="bordiv" placeholder="请选择省份" filterable @on-change="getCityList"
                                    style="width:167px;margin-right:10px;height:36px;margin-bottom:10px;" >
                                     <Option v-for="item in provinceArr" :key="item.id" :value="item.id" >{{ item.province}}</Option>
                                    </Select>
                                    <Select v-model="addModel.city_id" class="bordiv" placeholder="请选择城市" filterable
                                    style="width:440px;height:36px;margin-bottom:20px;" not-found-text="请先选择省份">
                                      <Option v-for="item in cities" :key="item.id" :value="item.id" >{{ item.city}}</Option>
                                    </Select>
                                    <Input v-model="addModel.address" class="bordiv" size="large" style="width:440px;" placeholder="详细地址" />
                                    <input type="text" autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>

                            <div class="list listpad">
                                <div class="fl_left name">报名周期<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <el-date-picker
                                        v-model="addDate"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="tanBtn" @click="saveExam">确定</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 裁剪 -->
            <div class="alertBox" v-show="cropShow" style="padding-top: 8%">
                <div style="background: #fff;width: 600px;height: 445px;margin:0 auto;
                padding-top: 20px;">
                    <div class="cropper">
                        <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :fixedBox="option.fixedBox"
                        >
                        </vueCropper>
                    </div>
                    <div style="width: 300px;margin: 0 auto;">
                        <div class="fl_left tanBtn tanBtned tanBtneds" @click="delCrop">取消</div>
                        <div class="fl_right tanBtn tanBtneds" @click="upload('base64')">确认裁剪</div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    province_id:'',
                    keyword:"",
                    page:1,
                },
                //添加model
                addModel:{
                    grading_test_id:'',
                    company_id:'',
                    level_id:[],
                    name:"",
                    province_id:'',
                    city_id:'',
                    address:'',
                    start_date:'',
                    end_date:'',
                },
                levelList:[],//级别
                addDate:['',''],
                imgd1:'',
                cropShow:false,
                option: {
                    img: '',//剪切图片地址
                    size: 1,//输出图片压缩比默认为1
                    full: false,//输出截图是否缩放
                    outputType: 'jpg',//输出图片格式
                    canMove: true,//是否可以拖动图片
                    fixedBox: true,//是否固定截图大小
                    original: false,//上传图片按原始比例
                    canMoveBox: false,//是否可以拖动截图框
                    autoCrop: true,//是否自成截图框
                    // 只有自动截图开启 宽度高度才生效
                    autoCropWidth: 300,//截图框宽
                    autoCropHeight: 300,//截图框高
                    centerBox: false,//截图框能否超过图片
                    high: true//是否根据dpr输出高清图片
                },
                provinceArr:[],
                cities:[],
                num:0,
                curRow:'',//当前行
                total:null,
                pageSize:10,
                loading:false,
                stop_reason:'',
                examColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },

                    {
                        title: '名称',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '考级级别',
                        align: 'center',
                        key: 'level'
                    },
                    {
                        title: '承办单位',
                        align: 'center',
                        key: 'company_name'
                    },
                    {
                        title: '报名二维码',
                        align: 'center',
                        key: 'level',
                        render: (h, params) => {
                            if(params.row.status==1||params.row.status==0){
                                return h('div',[
                                    // h('div',{
                                    //     // style:{
                                    //     //     color:'#999',
                                    //     // }
                                    // },params.row.level),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                if(params.row.status==1){
                                                    this.$Modal.success({
                                                        title: '扫描二维码入班',
                                                        render: (h) => {
                                                            return h('div',[
                                                                h('Img', {
                                                                    attrs: {
                                                                        src:params.row.qrcode,
                                                                    },
                                                                    style:{
                                                                        border:'1px solid #dcdcdc',
                                                                        width:'200px',
                                                                        display:'block',
                                                                        margin:'0 auto'
                                                                    },
                                                                    on: {
                                                                    }
                                                                }),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'center',
                                                                        lineHeight:'50px'
                                                                    },
                                                                },params.row.name),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'left',
                                                                        // marginBottom:'100px'
                                                                    },
                                                                },[
                                                                    h('div',{
                                                                        style:{
                                                                            padding:'8px 10px',
                                                                            border:'1px solid #dcdcdc',
                                                                            borderRadius:'4px',
                                                                            backgroundColor:'#e3e3e5',
                                                                            margin:'0 auto',
                                                                            cursor:'pointer',
                                                                            width:'100px',
                                                                            textAlign:'center'
                                                                        },
                                                                        on: {
                                                                            click: () => {
                                                                                this.copyUrl()
                                                                            }
                                                                        }
                                                                    },'复制网址'),
                                                                    h('a',{
                                                                        style:{
                                                                            color:'#1890ff',
                                                                            width:'260px',
                                                                            wordBreak:'break-word',
                                                                            float:'left',
                                                                            opacity:'0'
                                                                        },
                                                                        attrs:{
                                                                            href:params.row.jump_url,
                                                                            target:'_blank',
                                                                            id:'inviteCode'
                                                                        }
                                                                    },params.row.jump_url),
                                                                ])
                                                            ])
                                                        },
                                                        onOk: () => {

                                                        },
                                                        onCancel: () => {
                                                            // this.search(0)
                                                        }
                                                    })
                                                }
                                                else{
                                                    this.$Modal.confirm({
                                                        title: '提示',
                                                        content: '<p>确定要开启报名?</p>',
                                                        okText: '确定',
                                                        cancelText: '取消',
                                                        onOk: () => {
                                                            _this.$axios.post('changegradingteststatus',{
                                                                grading_test_id:params.row.id
                                                            }).then(res=>{
                                                                if(res.data.code==200){
                                                                    _this.$Message.success('操作成功');
                                                                    _this.getGradingTestList(0);
                                                                 }
                                                                 else{
                                                                     this.$Message.error(res.data.message);
                                                                 }
                                                            }).catch(function (error) {
                                                              console.log(error);
                                                            });
                                                        },
                                                        onCancel: () => {
                                                            // this.$Message.info('取消');
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }, '查看二维码'),
                                ]);
                            }
                            else{
                                return h('div',"-")
                            }
                        }
                    },
                    {
                        title: '考级城市',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', params.row.province+"-"+params.row.city);
                        }
                    },

                    {
                        title: '考级地址',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', params.row.address);
                        }
                    },
                    {
                        title: '考级时间',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', params.row.date_show);
                        }
                    },

                    {
                        title: '报名人数',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            let luder = JSON.stringify(_this.searchModel);
                                            localStorage.setItem("luder", luder);
                                            this.$router.push({
                                                path:'/stuexam/index/stulist',
                                                query:{
                                                    grading_test_id:params.row.id,
                                                    grading_test_name:params.row.name,
                                                }
                                            })
                                        }
                                    }
                                },  params.row.cur_num+'人')
                            ]);
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div',{
                                    style:{
                                        color:'#49c00e',
                                    }
                                },'报名中');
                            }
                            else if(params.row.status==0){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'未开启报名');
                            }
                            else if(params.row.status==2){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'已结束');
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            margin:'0 5px',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                let str=params.row.status==1?'关闭':'开启';
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要'+str+'报名?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('changegradingteststatus',{
                                                            grading_test_id:params.row.id
                                                        }).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('操作成功');
                                                                _this.getGradingTestList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, params.row.status==1?'关闭报名':'开启报名'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.addModel = params.row;
                                                _this.addModel.grading_test_id = params.row.id;
                                                _this.addDate = [];
                                                _this.addDate.push(new Date(params.row.start_date));
                                                _this.addDate.push(new Date(params.row.end_date));
                                                _this.getCityList();
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个报名?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deletegradingtest',{grading_test_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                this.getGradingTestList(0)
                                                                this.$Message.success('删除成功');
                                                            }
                                                            else{
                                                                this.$Message.error(res.data.message);
                                                            }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    },
                    {
                        title: '导出',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;

                                                _this.$axios.post('getgradingtestuserimgurl',{grading_test_id:params.row.id}).then(res=>{
                                                    if(res.data.code==200){
                                                        window.open(res.data.data);
                                                    }else{
                                                        _this.$Message.error(res.data.message);
                                                    }
                                                }).catch(function (error) {
                                                  console.log(error);
                                                });
                                            }
                                        }
                                    }, '证件照下载'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要导出该考级的名单汇总表?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('getuploadgradingtestuserurl',{grading_test_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                window.open(res.data.data);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '名单汇总表'),
                                ]);
                            // }
                        }
                    },
                ],
                examList: [],
                alertShow:false,
                company_id:'',
                company_name:'',
                clnum:1,
                companyList:[],
            }
        },
        methods:{

            //点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    _this.option.img=URL.createObjectURL(fileLen[0]);
                    _this.cropShow=true;
                    // _this.imgd1=URL.createObjectURL(fileLen[0]);
                    $('#file1').val('')
                }
            },
            //图片地址
            upload(type){
                let _this=this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64,fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob],new Date().getTime()+'.'+blob.type.split('/')[1],{type: "image/png"})
                        _this.uploadByOss(file)
                        if(_this.clnum==1){
                            _this.imgd1=dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop(){
                this.cropShow=false;
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                }
                return pwd;
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1]
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200',
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                                loading.close();
                                if(_this.clnum == 1){
                                    _this.addModel.logo = xhr.responseURL + re.dir + fileurl;
                                    _this.cropShow=false;
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }
                    })
                })
            },

            tandel(){
                this.alertShow=false;
            },
            //获取列表
            getGradingTestList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getgradingtestlist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.examList=res.data.data.list;

                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getGradingTestList(0);
            },
            //添加
            addExam(){
                let _this  = this;
                _this.addModel = {
                    grading_test_id:'',
                    company_id:'',
                    level_id:[],
                    name:"",
                    province_id:'',
                    city_id:'',
                    address:'',
                    start_date:'',
                    end_date:'',
                };
                _this.imgd1='';
                _this.addDate='';
                _this.alertShow=true;
            },
            //保存
            saveExam(){
                let _this=this;
                if(_this.addModel.name==''){
                    _this.$Message.error('请输入名称');
                }
                else if(_this.addModel.company_id===''){
                    _this.$Message.error('请选择承办单位');
                }
                else if(_this.addModel.province_id==''){
                    _this.$Message.error('请选择省份');
                }
                else if(_this.addModel.city_id.length == 0){
                    this.$Message.error('请选择城市');
                }
                else if(_this.addModel.address==''){
                    _this.$Message.error('请输入详细地址');
                }
                else if(_this.addDate[0]==''){
                    _this.$Message.error('请选择报名时间');
                }
                else{
                    _this.addModel.start_date   = _this.addDate[0];
                    _this.addModel.end_date     = _this.addDate[1];
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _url    = "";
                    if(_this.addModel.grading_test_id > 0){
                        _url = "editgradingtest";
                    }else{
                        _url = "addgradingtest";
                    }
                    _this.$axios.post(_url,_this.addModel).then(res=>{
                        loading.close();
                        if(res.data.code==200){
                            _this.alertShow=false;
                            _this.getGradingTestList(0);
                        }
                        else{
                            _this.$Message.error(res.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取省份列表
            getProvinceList(){
                let _this=this;
                _this.$axios.post('getprovincelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.provinceArr=res.data.data;
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取城市
            getCityList(){
                let _this=this;
                _this.$axios.post('getcitylist',{
                    province_id:_this.addModel.province_id
                }).then(res=>{
                    if(res.data.code==200){
                        _this.cities=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //获取城
            getCompanyList(){
                let _this=this;
                _this.$axios.post('getcompanyselect',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyList=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //复制网址
            copyUrl(data){
                var Url2 = document.getElementById("inviteCode").innerText;
                var oInput = document.createElement("input");
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = "oInput";
                oInput.style.display = "none";
                this.$Message.success('复制成功！');
            },
            //获取级别
            getlevel() {
                let _this = this;
                _this.$axios.post('getlevellist', {is_course:1}).then(res => {
                    if (res.data.code == 200) {
                        _this.levelList = res.data.data;
                    }
                    else {
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        },
        created(){
            let _this=this;
            let luder = JSON.parse(localStorage.getItem("luder"));
            _this.getProvinceList();
            if(luder!=null){
                _this.searchModel = luder;
            }
            _this.getGradingTestList();
            _this.getCompanyList();
            _this.getlevel();
        }
    }
</script>

<style scoped>
/**/
    .codeBtn{
        cursor:pointer;
        position: absolute;
        top: 2px;
        right: 0;
        width: 90px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #dc4e5a;
        color: #dc4e5a;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
    }
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .add {
        width: 150px;
        height: 150px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/logoadd.png) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
/**/
    /* .urlLogo{
        width: 150px;
        height: 210px;
        background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    } */
    .urlLogo1{
        width: 150px;
        height: 150px;
        border: solid 1px #e5e5e5;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/student_exam/index.vue